export default [
  { key: 'KJKTopKanzlei', value: 'KJKTopKanzlei' },
  { key: 'KJKStephanKolmann', value: 'KJKStephanKolmann' },
  { key: 'KJKTimJakobs', value: 'KJKTimJakobs' },
  { key: 'KJKCarlChristianKramer', value: 'KJKCarlChristianKramer' }
];
